"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var json_to_graphql_query_1 = require("json-to-graphql-query");
var TypeUtils_1 = require("./TypeUtils");
var VariableModel = (function (_super) {
    __extends(VariableModel, _super);
    function VariableModel(value, type, required, defaultValue) {
        if (required === void 0) { required = false; }
        var _this = _super.call(this, value) || this;
        _this.type = type;
        _this.required = required;
        _this.defaultValue = defaultValue;
        return _this;
    }
    VariableModel.prototype.getTypeString = function () {
        return this.type
            + (this.required === true ? '!' : '')
            + (TypeUtils_1.iDef(this.defaultValue) ? ' = ' + (typeof this.defaultValue === 'string' ? "\"" + this.defaultValue + "\"" : this.defaultValue) : '');
    };
    return VariableModel;
}(json_to_graphql_query_1.VariableType));
exports.VariableModel = VariableModel;
exports.addVariable = function (value, type, required, defaultValue) { return new VariableModel(value, type, required, defaultValue); };
exports.addEnum = function (value) { return new json_to_graphql_query_1.EnumType(value); };
//# sourceMappingURL=Variables.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/util/Variables.js
// module id = 789
// module chunks = 0